import React, { Component } from "react";
import {
  ActivityIndicator,
  Dimensions,
  StyleSheet,
  Text,
  View,
} from "react-native";
import AutoHeightImage from "react-native-auto-height-image";

import { Header } from "../components";
import DependencyList from "../components/DependencyList";
import { connect } from "react-redux";
import { APP_BASE_URL, getBaseUrl } from "../helpers/storage";
import fonts from "../constants/fonts";
import { API } from "../helpers/axios";

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentContainer: {
    paddingVertical: 30,
    paddingHorizontal: 5,
    backgroundColor: "#FFF",
    borderTopEndRadius: 30,
    borderTopStartRadius: 30,
  },
  imageContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    ...fonts.regular,
    fontSize: 22,
    textAlign: "center",
    marginTop: 10,
    marginHorizontal: 15,
    marginBottom: 30,
  },
});

class AskScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dependencies: [],
      loading: false,
    };
  }

  async fetchDependencies() {
    try {
      const { patientId } = this.props.navigation.state.params;
      const {
        data: { data: dependencyList },
      } = await API.get(`${APP_BASE_URL}/v2/profile/${patientId}/dependencies`);

      this.setState({
        dependencies: dependencyList || "",
      });
    } catch (error) {
      console.log(error?.response || error);
    }
  }

  setStaticData() {
    this.setState({
      dependencies: [
        {
          fullName: "Orang Tua",
          cardNumber: "parents",
        },
        {
          fullName: "Pasangan",
          cardNumber: "partner",
        },
        {
          fullName: "Anak",
          cardNumber: "children",
        },
      ],
    });
  }

  async componentDidMount() {
    const { config, dependenceStatus } = this.props.navigation.state.params;

    this.setState({ loading: true });

    try {
      // console.log({ config, dependenceStatus });
      // if (true) {
      if (config?.is_dependent_enabled && !!dependenceStatus) {
        await this.fetchDependencies();

        const { dependencies } = this.state;
        if (dependencies.length === 0) {
          this.setStaticData();
        }
      } else {
        this.setStaticData();
      }
    } catch {
      console.log("Dependency failed to fetch");
    }

    this.setState({ loading: false });
  }

  _handlePress = () => {
    this.props.navigation.goBack();
  };

  render() {
    const { loading } = this.state;
    return (
      <View
        style={[
          styles.container,
          { backgroundColor: this.props.themeColors.primary },
        ]}
      >
        <Header
          onPress={this._handlePress}
          position="start"
          text="Batal"
          theme="light"
        />
        <View style={styles.imageContainer}>
          <AutoHeightImage
            width={Dimensions.get("window").width - 120}
            source={require("../assets/illustrations/ask.png")}
          />
        </View>
        <View style={styles.contentContainer}>
          <Text
            style={[
              styles.text,
              { color: this.props.themeColors.darkestPrimary },
            ]}
          >
            Untuk siapakah konsultasi ini?
          </Text>

          {loading ? (
            <View
              style={{
                flex: 1,
                justifyContent: "center",
                paddingVertical: 50,
              }}
            >
              <ActivityIndicator
                size="large"
                color={this.props.themeColors.primary}
              />
            </View>
          ) : (
            <DependencyList
              data={this.state.dependencies.map((item) => {
                if (!!item["fullName"]) {
                  // from static data
                  return {
                    cardNumber: item.cardNumber,
                    fullName: item.fullName,
                    gender: "",
                    hasDoB: true,
                  };
                } else {
                  // from dynamic data
                  return {
                    cardNumber: item["card_number"],
                    fullName: item["first_name"] + " " + item["last_name"],
                    gender: item["gender"].toLowerCase(),
                    hasDoB: !!item.dob,
                  };
                }
              })}
              onSelect={(cardNumber, fullName, hasDoB) => {
                console.log({ hasDoB });
                this.props.navigation.replace("Symptoms", {
                  ...this.props.navigation.state.params,
                  policyNumber: cardNumber,
                  fullName,
                  hasDoB,
                  // patientId: this.props.navigation.state.params.patientId,
                  // hasViId: this.props.navigation.state.params.hasViId,
                  // enableVoiceCall: this.props.navigation.state.params
                  //   .enableVoiceCall,
                  // enableVideoCall: this.props.navigation.state.params
                  //   .enableVideoCall,
                });
              }}
            />
          )}
        </View>
      </View>
    );
  }
}

export default connect((state) => ({
  themeColors: state.themeColors,
}))(AskScreen);
